import Image from 'components/Image';

import APP from 'constants/app';

const Heading = () => (
  <Image
    alt="Gênio do Promobit dizendo que as melhores ofertas e promoções estão no Promobit"
    className="h-auto w-full rounded-t-4"
    height={104}
    src={`${APP.LOCAL_IMAGE_PATH}/features/login/genie.svg`}
    width={360}
  />
);

export default Heading;
